// extracted by mini-css-extract-plugin
module.exports = {"button":"Dice_button__8OyF9","number":"Dice_number__1vpic","wow":"Dice_wow__3sXiV","wee":"Dice_wee__broZ8","woo":"Dice_woo__9e6_f"};